import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { AdminFormRow } from '@ui';

type TextFieldRowProps<T extends FieldValues> = {
  title: string;
  name: FieldPath<T>;
  ariaLabel: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  type?: string;
};

export const TextFieldRow = <T extends FieldValues>({
  title,
  name,
  ariaLabel,
  isRequired,
  isDisabled,
  isReadOnly,
  type = 'text',
}: TextFieldRowProps<T>) => {
  const { control } = useFormContext<T>();

  return (
    <AdminFormRow title={title} isRequired={isRequired}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            aria-label={ariaLabel}
            type={type}
            isInvalid={fieldState.invalid}
            isDisabled={isDisabled}
            isReadOnly={isReadOnly}
            errorMessage={fieldState.error?.message}
          />
        )}
      />
    </AdminFormRow>
  );
};
